/**
 * Bloco "Contatos de emergência" (cadeia PAEBM) da aba Contatos — C-75.
 * Mesmos contatos do modal 🚨 do Header; aqui é onde o admin os edita (o modal
 * do Header fica só leitura). Dados por props (`useContatosDaAba`).
 */
import type { BlocoContatos } from '@/hooks/useContatosDaAba';
import type { ContatoGestao } from '@/services/datasources';
import LinhaContato from './LinhaContato';

interface Props {
  bloco: BlocoContatos;
  onEditar?: (contato: ContatoGestao) => void;
}

export default function ContatosEmergencia({ bloco, onEditar }: Props) {
  const { contatos, isLoading, isError } = bloco;
  return (
    <section
      aria-labelledby="contatos-emergencia-titulo"
      className="rounded-lg border border-jf-border border-l-[3px] border-l-red-500 bg-jf-surface p-3"
    >
      <h2 id="contatos-emergencia-titulo" className="text-sm font-bold text-white">
        🚨 Contatos de emergência
      </h2>
      <p className="text-[10px] text-jf-muted">Cadeia de acionamento do PAEBM — a mesma do botão 🚨 do topo.</p>

      {isLoading && <p className="mt-2 text-xs text-jf-dim">Carregando contatos…</p>}
      {isError && (
        <p className="mt-2 text-xs text-red-400">Não foi possível carregar os contatos de emergência.</p>
      )}
      {!isLoading && !isError && contatos.length === 0 && (
        <p className="mt-2 border-t border-jf-border pt-2 text-[11px] italic text-jf-dim">Nenhum contato cadastrado.</p>
      )}
      {contatos.length > 0 && (
        <ul className="mt-2">
          {contatos.map((c) => (
            <LinhaContato key={c.id} contato={c} onEditar={onEditar} />
          ))}
        </ul>
      )}
    </section>
  );
}
